import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Backdrop, Button } from '..';
import Wrapper from './style';

const Index = (props) => {
  const {
    isShow,
    title = 'Title Modal',
    subTitle,
    children,
    okType,
    okText = 'Save',
    okForm,
    okDanger,
    onCancel,
    okDisabled,
    width,
    className,
    onOk,
    cancelText,
    noFooter,
    headerComponent,
    isLoadingButton,
    emptyFooter,
    okHtmlType = 'submit',
    cancelType,
    showFooterLink,
    linkType,
    onLink,
    linkText,
    showCancelBtn = true,
    useBackdrop,
    minWidth,
    zIndexBackdrop,
  } = props;

  return (
    <>
      {useBackdrop && <Backdrop show={isShow} zIndex={zIndexBackdrop} />}
      <Wrapper
        isShow={isShow}
        width={width}
        minWidth={minWidth}
        useBackdrop={useBackdrop}
      >
        <div className="container_modal_wrapper">
          <div className={`container_modal_content ${className ?? ''}`}>
            <div className="component_header">
              {!headerComponent && (
                <>
                  <div className="component_header_title">
                    <div className="font-subtitle1_medium black1">{title}</div>
                    {subTitle && (
                      <div className="font-paragraph black1">{subTitle}</div>
                    )}
                  </div>
                  <CloseOutlined
                    className="component_header_close"
                    onClick={onCancel}
                  />
                </>
              )}
              {headerComponent && headerComponent}
            </div>
            <div className="component_body">{children}</div>
            {emptyFooter && <div className="component_empty_footer" />}
            {!noFooter && (
              <div className="component_footer">
                {showFooterLink && (
                  <Button
                    type={linkType || 'link'}
                    onClick={onLink}
                    htmlType="button"
                  >
                    {linkText ?? 'Link here'}
                  </Button>
                )}
                {showCancelBtn && (
                  <Button
                    type={cancelType || 'secondary'}
                    onClick={onCancel}
                    loading={isLoadingButton}
                    htmlType="button"
                  >
                    {cancelText ?? 'Cancel'}
                  </Button>
                )}
                <Button
                  type={okType || 'primary'}
                  form={okForm}
                  danger={okDanger}
                  disabled={okDisabled}
                  htmlType={okHtmlType}
                  onClick={onOk}
                  loading={isLoadingButton}
                >
                  {okText}
                </Button>
              </div>
            )}
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default Index;
